import { useToggle } from "@vueuse/core";

export function useToggleMenu() {
  const [isMenuOpen, toggleMenu] = useToggle(false);

  const openMenu = () => {
    isMenuOpen.value = true;
  };

  const closeMenu = () => {
    isMenuOpen.value = false;
  };

  return {
    isMenuOpen,
    toggleMenu,
    openMenu,
    closeMenu,
  };
}
